export default __webpack_public_path__ + "static/media/User-info.3b885d22.svg";